module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAyCAYAAABRYothAAAANUlEQVRIie3MMREAIAwEsAc5+F+4wxs46ELHREDGOvumwexIIhKJRKKCSCQqiUSikkj0LckDInEDAtTWMokAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/all/ic.png
// module id = c6ER
// module chunks = 0